<template>
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header_layout">
          <headerLayout
            :meun="meunItem"
            :title="meunTitle"
            :title2="headTitle"
          ></headerLayout>
        </el-header>
        <el-main class="main">
          <div class="mainTitle">{{ headTitle }}</div>
          <el-tabs
            class="elTabs"
            v-model="activeName"
            @tab-click="handleClick"
            v-if="initDatas"
          >
            <el-tab-pane label="企业详情" name="0">
              <enterprise-review-detail></enterprise-review-detail>
            </el-tab-pane>
            <el-tab-pane label="招聘岗位" name="1">
              <enterprise-wait-position
                @to-position="getName"
              ></enterprise-wait-position>
            </el-tab-pane>
          </el-tabs>
          <EnterpriseFoot
            v-if="activeName == '0'"
            v-on:activeName="touchNext"
          ></EnterpriseFoot>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import leftMeun from "@/components/layout/leftMeun";
import headRight from "@/components/layout/headRight";
import headerLayout from "@/components/layout/headerLayoutWxapp";
import EnterpriseFoot from "@/components/enterprise/enterpriseFoot";
import enterpriseReviewDetail from "@/components/enterprise/enterpriseReviewDetail";
import enterpriseWaitPosition from "@/components/enterprise/enterpriseWaitPosition";
export default {
  components: {
    leftMeun,
    headRight,
    headerLayout,
    EnterpriseFoot,
    enterpriseReviewDetail,
    enterpriseWaitPosition,
  },
  data() {
    return {
      initDatas: false,
      meunItem: null,
      meunTitle: "校友企业管理",
      headTitle: "",
      activeName: "0",
      info: {},
    };
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem;
      this.meunTitle = this.meunItem.name;
      this.headTitle = this.$route.query.title;
      this.initDatas = true;
      this.activeName = this.$route.query.index;
      console.log(this.headTitle);
    },
    getName(data) {
      console.log("看看", data);
    },
    handleClick(tab, event) {},
    touchNext(activeName) {
      this.activeName = "1";
    },
  },
};
</script>

<style>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  padding-bottom: 50px;
  margin-top: -30px;
  margin-left: -20px;
  margin-right: -20px;
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  /* padding-left: -20px; */
}
.elTabs {
  margin-top: -40px;
  /* padding-left: 15px; */
  /* margin-left: 24px;
  margin-right: 24px; */
}
</style>



// WEBPACK FOOTER //
// src/pages/wxapp/enterpriseReview.vue